import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_labeling_materials_containing_asbestos_exposure_areas'

export const dataPointDefinition = {
  retracedId: 'no_labeling_materials_containing_asbestos_exposure_areas',
  name: 'No labeling of materials containing asbestos and/or asbestos exposure areas',
  description:
    'If the facility does not have materials containing asbestos/asbestos exposure areas, answer Not Applicable.',
  meta: {
    slcpMeta: {
      key: 'hs-bui-58x',
      number: 'HS-BUI-16-3',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: 'hs-bui-55',
      optionList: 'xna',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2]',
      machineShowHide: '[2]',
      completionCondition: 'any ms',
    },
    multiSelectKey: 'hs-bui-55',
  },
  fieldTypeId: 'MULTI_SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'xna',
      name: 'xna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'string',
          enum: ['xna'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-bui-58x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29850,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
